const ORDER_TAB_WAIT_PAYMENT = 0;
const ORDER_TAB_WAIT_CONFIRM = 1;
const ORDER_TAB_WAIT_DELIVER = 1;
const ORDER_TAB_DELIVERED = 2;
const ORDER_TAB_CANCELED = 2;

export { ORDER_TAB_CANCELED, ORDER_TAB_DELIVERED, ORDER_TAB_WAIT_CONFIRM, ORDER_TAB_WAIT_DELIVER, ORDER_TAB_WAIT_PAYMENT };
